import { useQuery } from '@tanstack/react-query';
import { getMembershipTemplatesListAPI } from '@/api/memberShip';
import { getItemWithExpiration } from '@/lib/utils';

/**
 * 정산 분류별 상품 수 — 예외 수업료 창에서 「이 분류가 붙은 상품이 몇 개인지」 보여 주려고 센다.
 * 새 서버 API 없이 상품 화면이 쓰는 상품 목록(GET v1/membershipTemplates)을 같은 캐시 키로 읽는다.
 * 목록을 못 읽으면(실패·구서버 형식) null — 호출부는 개수 표시를 생략한다.
 */
export const countTemplatesByCategory = (templates: unknown): Map<string, number> | null => {
    if (!Array.isArray(templates)) return null;
    const counts = new Map<string, number>();
    for (const template of templates) {
        const key = (template as { settlementCategoryKey?: unknown } | null)?.settlementCategoryKey;
        if (typeof key === 'string' && key) counts.set(key, (counts.get(key) ?? 0) + 1);
    }
    return counts;
};

/** 상품 화면(ClassPassPage)과 같은 키 — 한쪽에서 받은 목록을 다른 쪽이 그대로 쓴다. */
const TEMPLATE_LIST_QUERY_KEY = ['getMembershipTemplatesListAPI'];

export const useTemplateCountsByCategory = ({ centerId, enabled = true }: { centerId: string; enabled?: boolean }) => {
    const authorization = getItemWithExpiration('authorization');
    const query = useQuery({
        queryKey: TEMPLATE_LIST_QUERY_KEY,
        queryFn: async () => await getMembershipTemplatesListAPI(authorization, centerId),
        // 전역 기본값이 enabled:false 라 반드시 명시한다.
        enabled: enabled && !!authorization && !!centerId,
        retry: false,
    });
    const res: any = query.data;
    return res?.status === 200 ? countTemplatesByCategory(res?.data?.membershipTemplates) : null;
};
